import {
  Alert,
  Dialog,
  Flex,
  FlexColumn,
} from '@elementary/common-ui/components';
import { styled, Typography } from '@mui/material';
import { ReactComponent as InfoIconBase } from '@elementary/common-ui/assets/16x16/info.svg';
import SensitiveInfoDisplay from './SensitiveInfoDisplay';

const InfoIcon = styled(InfoIconBase)`
  path {
    fill: ${({ theme }) => theme.palette.common.gray4};
  }
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  token: string;
  tokenType: 'personal' | 'account';
};

const SuccessStageDialog = ({ isOpen, onClose, token, tokenType }: Props) => {
  const tokenTypeLabel = tokenType === 'personal' ? 'user' : 'account';
  const permissionLabel =
    tokenType === 'personal' ? 'user permissions' : 'account permissions';

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      onConfirmButtonClick={onClose}
      title="Generate token"
      confirmText="Done"
      hideCancelButton
      closeOnBackdropClick={false}
      footerMessage={
        <Flex sx={{ gap: 1, alignItems: 'center' }}>
          <InfoIcon />
          <Typography sx={{ fontSize: '12px', color: 'common.gray4' }}>
            Notice: This key is unique and tied to your {permissionLabel}.
          </Typography>
        </Flex>
      }
      message={
        <FlexColumn sx={{ gap: 3 }}>
          <Alert severity="info">
            Copy and save the {tokenTypeLabel} token below —{' '}
            <span style={{ fontWeight: 'bold' }}>
              it won&apos;t be shown again.
            </span>
          </Alert>

          <SensitiveInfoDisplay
            label={tokenType === 'personal' ? 'User token' : 'Account token'}
            value={token}
          />
        </FlexColumn>
      }
    />
  );
};

export default SuccessStageDialog;
